/**
 * 문제집 관리 페이지
 * - 문제집 목록 테이블
 * - 필터 (연도, 학년, 학기)
 * - 배정 모달
 */

import React, { useState } from 'react';
import { Card } from 'antd';
import { WorkbookTable } from '../../components/workbooks/WorkbookTable';
import { WorkbookFilters, WorkbookFilterState } from '../../components/workbooks/WorkbookFilters';
import { AssignWorkbookModal } from '../../components/workbooks/AssignWorkbookModal';
import type { Workbook } from '../../types/workbook';

/**
 * WorkbooksPage 컴포넌트
 * 문제집 목록 페이지
 */
export const WorkbooksPage: React.FC = () => {
  // 필터 상태
  const [filters, setFilters] = useState<WorkbookFilterState>({});

  // 배정 모달 상태
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [selectedWorkbook, setSelectedWorkbook] = useState<Workbook | null>(null);

  // 테이블 새로고침 트리거
  const [refreshKey, setRefreshKey] = useState(0);

  /**
   * 필터 변경 처리
   */
  const handleFilterChange = (newFilters: WorkbookFilterState) => {
    setFilters(newFilters);
  };

  /**
   * 배정 모달 열기
   */
  const handleAssign = (workbook: Workbook) => {
    setSelectedWorkbook(workbook);
    setAssignModalOpen(true);
  };

  /**
   * 배정 성공 처리
   */
  const handleAssignSuccess = () => {
    setRefreshKey((prev) => prev + 1); // 테이블 새로고침
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card title="문제집 관리">
        {/* 필터 */}
        <WorkbookFilters onFilter={handleFilterChange} />

        {/* 테이블 */}
        <WorkbookTable
          filters={filters}
          onAssign={handleAssign}
          refreshTrigger={refreshKey}
        />
      </Card>

      {/* 배정 모달 */}
      <AssignWorkbookModal
        open={assignModalOpen}
        workbook={selectedWorkbook}
        onClose={() => {
          setAssignModalOpen(false);
          setSelectedWorkbook(null);
        }}
        onSuccess={handleAssignSuccess}
      />
    </div>
  );
};
